module.exports = __webpack_public_path__ + "img/camcoder.18a2233b.svg";